// extracted by mini-css-extract-plugin
export const accordion = "DifferencePointAccordion-module--accordion--3k097";
export const isOpen = "DifferencePointAccordion-module--is-open--2j2oS";
export const accordionTitle = "DifferencePointAccordion-module--accordion-title--1e5nh";
export const accordionNotice = "DifferencePointAccordion-module--accordion-notice--3siaa";
export const isThumbnailFirst = "DifferencePointAccordion-module--is-thumbnail-first--27zTv";
export const accordionIcon = "DifferencePointAccordion-module--accordion-icon--3HfWP";
export const iconArea = "DifferencePointAccordion-module--icon-area--26qP5";
export const panel = "DifferencePointAccordion-module--panel--11gO7";